import React from "react";

// Redux
import {useSelector, useDispatch} from "react-redux";
import {createEventVenue} from "../../../redux/features/events/venuesSlice";

// Routing
import {useHistory} from "react-router-dom";

// Components
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Paper from "../../UI/MainPaper";
import EventVenuesForm from "./EventVenuesForm";
import Breadcrumbs from "../../Navigation/Breadcrumbs";

const EventVenuesNew = () => {
  // Redux
  const dispatch = useDispatch();
  const {isLoading} = useSelector(state => state.eventVenues);

  // Routing
  const history = useHistory();

  const breadcrumbNameMap = {
    "/events": "Events",
    "/events/venues": "Event Venues",
    "/events/venues/new": "New Event Venue",
  };

  const onCancel = () => {
    history.push("/events/venues");
  };
  const onSubmit = async values => {
    const eventVenueObj = {
      venue_id: null,
      ...values,
    };

    const res = await dispatch(createEventVenue(eventVenueObj));
    // If event was created successfully redirect to events page and show user
    if (!res.error) {
      history.push({
        pathname: "/events/venues",
        state: {
          showSuccess: true,
          snackbarContent: `Your Event Venue '${eventVenueObj.name}' was successfully created!`,
          snackbarLink: `/events/venues/${res.id}`,
        },
      });
    }
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Breadcrumbs breadcrumbNameMap={breadcrumbNameMap} />
      </Grid>
      <Grid item xs={12}>
        <Paper>
          <Typography component="h1" variant="h5" gutterBottom>
            New Event Venue
          </Typography>
          <EventVenuesForm
            onSubmit={onSubmit}
            onCancel={onCancel}
            isLoading={isLoading}
            submitButtonLabel="Create Event Venue"
          />
        </Paper>
      </Grid>
    </Grid>
  );
};

export default EventVenuesNew;
